export function calcAvgMoisture(moisture: number, wetMass: number) {
  return {
    q: wetMass ? (moisture / wetMass) * 100 : 0,
    u: 'percent',
  };
}

function extractMin(label: string) {
  if (label.startsWith('>')) {
    return Infinity;
  }

  if (label.startsWith('<')) {
    return -Infinity;
  }

  const minRangeMatch = label.match(/[\d.]+/);

  return minRangeMatch && minRangeMatch.length > 0 ? parseFloat(minRangeMatch[0]) : -Infinity;
}

interface LabelObject {
  label: string;
}

export function sortDescDataByLabelRanges(item1: LabelObject, item2: LabelObject): number {
  const minItem1 = extractMin(item1.label);
  const minItem2 = extractMin(item2.label);

  if (minItem1 < minItem2) return 1;
  if (minItem1 > minItem2) return -1;
  return 0;
}

export function sortDescDataByLabel(item1: LabelObject, item2: LabelObject): number {
  return item2.label.localeCompare(item1.label);
}

export function parseAppliedApplicationsData(data) {
  return data.map((application) => ({
    area: application.appliedYield.area,
    averageYield: application.appliedYield.averageYield,
    label: application.applicationPassName,
    ...application
  }))
}